import { type ComponentType, type LazyExoticComponent, lazy } from 'react';

/**
 * Turns a named export into a React lazy component without making every route
 * repeat the `{ default: ... }` adapter required by `React.lazy`.
 */
export function lazyComponent<Props>(load: () => Promise<ComponentType<Props>>): LazyExoticComponent<ComponentType<Props>> {
  return lazy(async () => ({ default: await load() }));
}
